import { legacy_createStore as createStore, applyMiddleware, compose } from 'redux';
import createSagaMiddleware from 'redux-saga';
import rootReducer from './reducers';
import rootSaga from './sagas';
import { createLogger } from 'redux-logger';

const sagaMiddleware = createSagaMiddleware();
const isDev = process.env.NODE_ENV === 'development';
const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

const logger = createLogger({
  collapsed: true,
  duration: true,
  timestamp: true,
});

const middlewareList = [sagaMiddleware];
if (isDev) {
  middlewareList.push(logger);
}

const store = createStore(
  rootReducer,
  composeEnhancers(applyMiddleware(...middlewareList))
);
sagaMiddleware.run(rootSaga);

export { store };
